// extracted by mini-css-extract-plugin
export default {"container":"TextSection_container__LdKaU","title":"TextSection_title__m2DdP","text":"TextSection_text__s6Fly","blur1":"TextSection_blur1__fx6+i","blur2":"TextSection_blur2__LYSmB"};